import {User} from '../../types/interfaces';


export class FetchUsers {
  static readonly type = '[Users] Fetch All';

  constructor(public payload: User[]) {
  }
}
